import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EquipmentInformation from '../equipmentInformation';
import ReadableParameterList from '../readableParameterList';
import WritableParameterList from '../writableParameterList';
import EquipmentAlert from '../equipmentAlert';
import { useHook as equipmentInfo } from '../useHook';
import { useDispatch, useSelector } from 'react-redux';
import { setInviteMemberAction } from '../../../../stores/actionTypes/equipmentInfoActions';
interface ChildComponentProps {
  setRefreshFunction: (handleRefreshClick: () => void) => void;
}
const OwnedEquipmentDetails: React.FC<ChildComponentProps> = ({
  setRefreshFunction,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { fetchGetEquipmentDetails } = equipmentInfo();
  const { customerEquipmentDetails } = useSelector(
    (state: any) => state.equipmetInfo,
  );
  const [refreshKey, setRefreshKey] = useState(0);
  let childRefreshFunction: () => void;

  const setChildRefreshFunction = (refreshFunc: () => void) => {
    childRefreshFunction = refreshFunc;
  };

  const handleRefreshClick = () => {
    if (childRefreshFunction) {
      childRefreshFunction(); // Trigger the child component's refresh function
    }
    getEquipmentDetails();
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const getEquipmentDetails = async () => {
    const payload = {
      unitID: id,
    };
    await fetchGetEquipmentDetails(payload);
  };

  useEffect(() => {
    getEquipmentDetails();
    dispatch(setInviteMemberAction([]));
    sessionStorage.removeItem('paramPayload');
  }, []);

  useEffect(() => {
    setRefreshFunction(handleRefreshClick);
  }, [setRefreshFunction]);

  return (
    <>
      <EquipmentInformation
        equipmentDetailsData={customerEquipmentDetails}
        equipmentPage="ownedEquipment"
      />

      <ReadableParameterList
        equipmentDetailsData={customerEquipmentDetails}
        setRefreshFunction={setChildRefreshFunction}
      />

      <WritableParameterList
        equipmentDetailsData={customerEquipmentDetails}
        equipmentPage="ownedEquipment"
        refreshKey={refreshKey}
      />

      <EquipmentAlert
        equipmentDetailsData={customerEquipmentDetails}
        refreshKey={refreshKey}
      />
    </>
  );
};

export default OwnedEquipmentDetails;
